<template>
  <div class="privacy-page">
    <div class="privacy-page__backdrop" aria-hidden="true"></div>
    <div class="privacy-page__inner">
      <header class="privacy-page__header">
        <button type="button" class="privacy-page__back" @click="goBack">
          <i class="fas fa-arrow-left"></i>
          返回
        </button>
        <h1 class="privacy-page__title">idoing 隐私政策</h1>
        <p class="privacy-page__meta">
          <span>发布日期：2026 年 03 月 10 日</span>
          <span class="privacy-page__meta-sep">·</span>
          <span>生效日期：2026 年 03 月 17 日</span>
        </p>
      </header>

      <article class="privacy-doc">
        <p class="privacy-doc__lead">
          欢迎您使用 idoing 产品与服务！
        </p>
        <p>
          「idoing」指 idoing 产品运营方及其关联方（以下称「我们」）合法拥有并运营的 idoing
          客户端应用程序、官方网站及相关服务。
        </p>
        <p>
          我们非常重视用户（以下简称「您」）的隐私和个人信息保护。您在使用我们的产品与/或服务时，我们可能会收集和使用您的相关个人信息。我们通过本隐私政策向您说明
          idoing 在提供产品与/或服务时如何收集、使用、保存、共享和转让您的个人信息、您享有的个人信息权利以及
          idoing 如何保障您的个人信息安全。
        </p>
        <p>
          本隐私政策与您所使用的 idoing 以及该服务所包括的各种业务功能（以下统称「我们的产品与/或服务」）息息相关，希望您在使用我们的产品与/或服务前仔细阅读并确认您已经充分知悉并理解本政策所陈述的内容，并让您可以按照本隐私政策的指引做出您认为适当的选择。一旦您开始使用或在我们更新本隐私政策后继续使用我们的产品与/或服务，即表示您已充分理解并同意本政策（含更新版本）内容，并且同意我们按照本隐私政策收集、使用、保存和共享您的相关信息。
        </p>

        <nav class="privacy-doc__toc">
          <p class="privacy-doc__toc-title">本隐私政策将帮助您了解以下内容：</p>
          <ol>
            <li><a href="#section-1">一、本隐私政策适用范围</a></li>
            <li><a href="#section-2">二、我们如何收集和使用您的个人信息</a></li>
            <li><a href="#section-3">三、我们如何使用 Cookie 和同类技术</a></li>
            <li><a href="#section-4">四、我们如何共享、转让、公开披露您的个人信息</a></li>
            <li><a href="#section-5">五、我们如何保护和保存您的个人信息</a></li>
            <li><a href="#section-6">六、您如何管理个人信息</a></li>
            <li><a href="#section-7">七、未成年人信息的保护</a></li>
            <li><a href="#section-8">八、本政策如何更新</a></li>
            <li><a href="#section-9">九、如何联系我们</a></li>
          </ol>
        </nav>

        <section id="section-1" class="privacy-doc__section">
          <h2>一、本隐私政策适用范围</h2>
          <ol>
            <li>
              本隐私政策适用于您通过 idoing 网页、客户端应用程序、供第三方网站和应用程序使用的
              idoing 软件开发工具包（SDK）和应用程序编程接口（API）方式来访问和使用我们的产品和服务，但如该产品与/或服务单独设置了隐私条款/隐私协议的，单独的隐私条款/隐私协议优先适用，单独的隐私条款/隐私协议未提及的内容，适用本政策。
            </li>
            <li>
              本政策不适用于以下情况：
              <ul>
                <li>（1）我们的产品与/或服务中包含的或链接至第三方提供的信息与/或第三方服务（包括任何第三方应用、网站、产品、服务等），这些信息与/或服务由第三方负责运营，您使用该信息与/或服务适用第三方另行向您说明的个人信息收集、使用的规则。</li>
                <li>（2）其他非 idoing 向您提供的产品与/或服务内容。</li>
              </ul>
            </li>
          </ol>
        </section>

        <section id="section-2" class="privacy-doc__section">
          <h2>二、我们如何收集和使用您的个人信息</h2>
          <p>
            我们会根据合法正当、最小必要、公开透明的原则，基于本政策所述的目的，收集和使用您的个人信息。如果我们将您的个人信息用于本政策未载明的其他用途，或基于其他特定目的而收集和使用您的个人信息，我们将以合理的方式（包括但不限于通过更新本政策、重新签署文件、页面提示、弹窗、站内信、邮件、网站公告或其他便于您获知的方式）另行向您详细说明对应信息的收集、使用目的、方式、范围等规则，并确保这些新需求仍然符合合法、正当、必要的原则，避免超出原有范围，在征得您授权同意后收集和使用。
          </p>
          <p>
            相机、麦克风、相册等系统权限，均不会默认开启，只有经过您的明示授权才会在为实现特定功能/服务时访问，您可以随时撤回授权。特别需要指出的是，即使经过您的授权，可以访问您的相应权限，我们仅会在您的授权范围内进行访问；且如您拒绝提供的，仅会使您无法使用相应功能，但并不影响您正常使用产品与/或服务的其他功能。
          </p>
          <p>为了向您提供服务，我们会按照如下方式收集、使用您的个人信息：</p>

          <h3>（一）使用 idoing 产品或服务所必须的功能</h3>
          <ol>
            <li>
              <strong>账号注册信息</strong>：当您首次注册 idoing 账号时，您需要使用<strong>实名认证的手机号码</strong>进行注册，并创建登录密码。我们在此明确提示您，手机号码将用于实名认证，登录密码应符合复杂度要求以确保账户安全。上述信息为您注册
              idoing 账号所必需，若您拒绝提供这类信息，您将无法注册 idoing 平台账户，仅可以使用浏览、搜索服务。当您成功注册账号后，您可以通过手机号码和短信验证码登录
              idoing 产品或服务，也可通过手机号码和密码登录 idoing 产品或服务。
            </li>
            <li>
              <strong>统一账号</strong>：idoing 各关联版本均使用统一的 idoing 账号服务。您可以使用 idoing
              账号便捷地登录、使用 idoing 各关联平台，以使用对应平台的服务或功能。为了在 idoing
              各关联平台中提供一致的服务体验，我们可能使用 SDK 或相关技术同步各关联平台中的账号和内容，其中可能包括：共享昵称、头像等您设置为公开的账号信息；同步您使用此账号点赞、收藏、生成及发布的内容；同步您授权的其他信息。
            </li>
            <li>
              <strong>内容生成服务</strong>：基于人工智能（以下简称「AI」）模型技术，idoing 向您提供 AI
              内容生成（图片、音视频等内容）等服务。为了向您提供服务，我们会收集您主动选择或输入的文字、图片、音视频等内容及指令。我们会对上述信息进行分析，以便于更好地为您生成符合您指令和要求的内容。同时，在经过安全加密技术处理、严格去标识化且无法重新识别特定个人的前提下，我们可能会将所收集的数据以及模型生成的对应内容用于模型优化，并不断调整优化模型的效果。
              <br />
              为了实现相关功能，我们可能会基于技术原因将您主动选择或上传的原始素材内容上传至服务端处理。其中，部分功能可能需要对包含人脸、声音的素材内容进行分析处理。但请放心，这些内容将仅被允许用于实现包含「人像处理」相关指令、或「数字人」等相关功能与服务的生成效果，而绝不会用于识别特定个人、或验证个人身份等其他目的。
              <br />
              您在使用 AI 内容生成时（包括但不限于导入素材、导出生成内容等），我们会根据您具体使用到的功能和服务类型请求您授权麦克风、摄像头、相册或存储等权限。如果您拒绝授权，您将无法使用导入素材、导出生成内容等功能，但不影响您使用
              idoing 的其他功能。
            </li>
            <li>
              <strong>内容浏览与搜索</strong>：当您浏览 idoing 内容的过程中，我们会记录您的使用情况。如果您未登录账号，我们会通过设备对应的标识符信息来记录您的点击、浏览、下载、分享、反馈信息。如果您已登录账号，我们会通过您的账号记录您的点击、浏览、下载、分享、关注、反馈、做同款、发布、点赞、评论等。当您使用搜索服务时，我们会收集您的搜索关键字信息、日志信息记录进行分析以便向您展现相关程度更高的搜索结果。我们还可能会记录您在使用我们服务时提供、形成或留存的信息，如您在使用搜索时输入查询词，点击历史词、提示词和点击的链接。您有权拒绝提供上述信息，但这将导致您可能无法使用特定服务或功能，或者无法达到相关服务拟达到的效果。
            </li>
            <li>
              <strong>模型及信息发布</strong>：当您上传模型或图片、音视频内容时，我们会根据您使用的功能和服务类型请求您授权相册、麦克风、摄像头等权限。如果您拒绝授权，将无法使用相应发布功能，但不影响您使用
              idoing 的其他功能。您发布的内容中会展示您的昵称、头像等信息。为不断优化我们的产品服务，持续改善我们的内容生态、互动效果及使用体验，我们会基于您公开发布的模型、图片、音视频等作品的时长以及该等作品的观看、互动、使用等情况进行效果统计及分析，并对外公开展示部分统计数据。
            </li>
            <li>
              在您分享或接收被分享的信息、参加活动等情形下，idoing 客户端将在本地访问您的剪切板，写入口令或读取其中包含的口令、分享码、链接，以实现跳转、分享、活动联动等功能或服务。我们不会上传您剪切板中的信息至我们的服务器。
            </li>
          </ol>

          <h3>（二）向您提供产品或服务</h3>
          <p>当您使用 idoing 服务时，为了维护我们服务的正常运行，改进及优化我们的服务体验以及保障您的账号安全，我们会收集您下述信息：</p>
          <ol>
            <li><strong>设备信息</strong>：我们会根据您在软件安装及使用中授予的具体权限，接收并记录您所使用的设备相关信息（包括设备型号、操作系统版本、IP 地址、软件版本号等软硬件特征信息）。</li>
            <li><strong>日志信息</strong>：我们会收集您对我们服务的详细使用情况，作为有关日志保存，包括接入网络的方式、类型和状态、网络质量数据、操作日志、服务日志信息。</li>
            <li><strong>您通过我们的客服或参加我们举办的活动时所提交的个人信息</strong>：您知悉并同意，我们在运营中可能会通过您在使用产品或服务的过程中所提供的联系方式（例如：电话号码），向您同时发送一种或多种类型的通知，例如消息告知、身份验证、安全验证、用户使用体验调研；此外，我们也可能会以短信、电话的方式，为您提供您可能感兴趣的服务、功能或活动等商业性信息。如果您不愿接受这些信息，您可以通过手机短信中提供的退订方式进行退订，也可以直接与我们联系进行退订。</li>
          </ol>

          <h3>（三）运营与安全运行</h3>
          <p>为了维护相关产品或服务的正常稳定运行，保护您或其他用户或公众的安全及合法利益，我们会收集如下必要信息：</p>
          <ul>
            <li>（1）为了保障软件与服务的安全运行、运营的质量及效率，我们会收集您的硬件型号、操作系统版本号、设备标识符、运营商统一匿名标识符、网络设备硬件地址（设备 MAC 地址）、IP 地址、WLAN 接入点、蓝牙、基站、软件版本号、网络接入方式/类型/状态、网络质量数据、操作/使用/服务日志、设备传感器数据等数据。</li>
            <li>（2）为了预防恶意程序、保障运营质量及效率，我们会收集安装的应用列表信息、软件列表或正在运行的进程信息、应用程序的总体运行、使用情况与频率、应用崩溃情况、总体安装使用情况、性能数据、应用来源。</li>
            <li>（3）我们可能收集您使用 idoing 过程中产生的账号信息、设备信息、服务日志信息，使用上述信息以及我们的关联方、合作方获得您授权或依法可以提供给我们的信息，用于判断账号安全、交易安全、进行身份验证、识别违法违规情况、检测及防范安全事件，并依法采取必要的记录、分析、处置措施。</li>
          </ul>

          <h3>（四）其他用途</h3>
          <p>
            如果我们基于本政策未载明的其他特定目的收集您的个人信息时，会事先征求您的授权同意。我们收集及使用上述信息的目的是为了更好地经营
            idoing 产品和服务，如有更新我们会通过包括但不限于网站公告、站内信、电话或短信等方式通知您。
          </p>
          <p>
            如我们停止运营 idoing 产品或服务，我们将及时停止继续收集您个人信息的活动，将停止运营的通知在至少 30
            日内以逐一送达或通过公告的形式告知您，并对所持有的个人信息进行删除或匿名化处理。涉及儿童个人信息的，我们会并将停止运营的通知及时告知儿童监护人。
          </p>

          <h3>（五）授权同意的例外</h3>
          <p>您充分知晓，根据相关法律法规的要求以下情形中，我们收集、使用您的个人信息无需征得您的授权同意：</p>
          <ol>
            <li>与个人信息控制者履行法律法规规定的义务相关的；</li>
            <li>与国家安全、国防安全直接相关的；</li>
            <li>与公共安全、公共卫生、重大公共利益直接相关的；</li>
            <li>与刑事侦查、起诉、审判和判决执行等直接相关的；</li>
            <li>出于维护个人信息主体或其他个人的生命、财产等重大合法权益但又很难得到本人授权同意的；</li>
            <li>所涉及的个人信息是个人信息主体自行向社会公众公开的；</li>
            <li>根据个人信息主体要求签订和履行合同所必需的；</li>
            <li>从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道；</li>
            <li>维护所提供产品或服务的安全稳定运行所必需的，如发现、处置产品或服务的故障；</li>
            <li>个人信息控制者为新闻单位，且其开展合法的新闻报道所必需的；</li>
            <li>个人信息控制者为学术研究机构，出于公共利益开展统计或学术研究所必要，且其对外提供学术研究或描述的结果时，对结果中所包含的个人信息进行去标识化处理的。</li>
          </ol>
          <p>
            特别提示您注意，如信息无法单独或结合其他信息识别到您的个人身份，其不属于法律意义上您的个人信息；当您的信息可以单独或结合其他信息识别到您的个人身份时或我们将无法与任何特定个人信息建立联系的数据与其他您的个人信息结合使用时，这些信息在结合使用期间，将作为您的个人信息按照本政策处理与保护。
          </p>
        </section>

        <section id="section-3" class="privacy-doc__section">
          <h2>三、我们如何使用 Cookie 和同类技术</h2>
          <p>
            为使您获得更轻松的访问体验，您使用我们的产品或服务时，我们可能会通过采用各种技术收集和存储您访问 idoing
            服务的相关数据，包括但不限于您的设备信息、登录信息、浏览记录等，在您访问或再次访问 idoing
            服务时，我们能识别您的身份，并通过分析数据为您提供更好更多的服务。包括使用小型数据文件识别您的身份，这么做是为了解您的使用习惯，帮您省去重复输入账户信息的步骤，或者帮助判断您的登录状态以及账户安全。这些数据文件可能是
            Cookie，或您的浏览器或关联应用程序提供的其他本地存储（统称「Cookie」）。
          </p>
          <p>
            我们不会将 Cookies 用于本隐私政策所述目的之外的任何用途。您可根据自己的偏好管理或删除 Cookies。您可以清除计算机上保存的所有
            Cookies，大部分网络浏览器会自动接受 Cookies，但您通常可根据自己的需要来修改浏览器的设置以拒绝
            Cookies；另外，您也可以清除软件内保存的所有 Cookies。
          </p>
          <p>
            您理解并知悉：我们的某些产品/服务只能通过使用 Cookie 或同类技术才可得到实现，如您拒绝使用或删除的，您将可能无法获得我们的产品与/或服务的最佳的服务体验，同时也可能会对您的信息保护和账号安全性造成一定的影响。
          </p>
        </section>

        <section id="section-4" class="privacy-doc__section">
          <h2>四、我们如何共享、转让、公开披露您的个人信息</h2>
          <h3>（一）共享</h3>
          <p>
            我们非常重视保护您的个人信息。未经您的授权同意，我们不会与其他第三方公司、组织和个人共享您的个人信息，除非是匿名化或去标识化处理后的无法识别或关联到您的信息，且共享第三方无法重新识别此类信息的自然人主体。我们仅会出于合法、正当、必要、特定、明确的目的共享您的个人信息，并且只会共享必要的个人信息。如果我们共享您的个人敏感信息，我们会将再次征求您的授权同意。如果第三方超出原授权范围使用您的个人信息，则我们会要求第三方再次征得您的授权同意。
          </p>
          <ol>
            <li><strong>为实现我们的服务/功能所必需进行的共享</strong>：例如为支付服务提供商提供订单支付相关信息；我们接受尽职调查或审计时，与外部监管、专业咨询机构等共享您的相关信息。</li>
            <li><strong>与 idoing 内部的必要、合理共享</strong>：为便于我们基于统一的账号体系向您提供一致化服务、识别账号异常、保护用户或公众的人身财产安全免遭侵害，您的相关个人信息可能会在我们的产品内部进行必要共享。</li>
            <li><strong>实现安全与分析统计的共享信息</strong>：为保障使用安全、分析产品使用情况，我们可能与关联方或第三方共享必要的设备、账号、日志信息或统计性数据，这些数据难以与其他信息结合识别您的个人身份。</li>
            <li><strong>帮助您参加营销推广活动</strong>：当您选择参加我们及关联方或第三方举办的有关营销活动时，可能需要您提供姓名、联系方式、银行账号信息。未经您单独授权同意，我们不会与其共享可以识别您身份的个人信息。</li>
            <li><strong>其他情形</strong>：为保护您、我们的其他用户或员工、idoing 或社会公共利益免遭损害而与第三方共享；依据您与我们签署的相关协议或法律文件而共享；符合您与其他第三人之间的有关约定。</li>
          </ol>

          <h3>（二）转让</h3>
          <p>我们不会将您的个人信息转让给任何公司、组织和个人，但以下情况除外：</p>
          <ol>
            <li>在获取明确同意的情况下转让：获得您的明确同意后，我们会向其他方转让您的个人信息。</li>
            <li>在 idoing 服务提供者发生合并、收购或破产清算情形，或其他涉及合并、收购或破产清算情形时，如涉及到个人信息转让，我们会要求新的持有您个人信息的公司、组织继续受本政策的约束，否则我们将要求该公司、组织和个人重新向您征求授权同意。</li>
          </ol>

          <h3>（三）公开披露</h3>
          <ol>
            <li>除符合法律法规的规定进行公开披露或获得您授权同意外，我们不会公开披露您的信息，且我们公开披露您的个人信息会采用符合行业内标准的安全保护措施。</li>
            <li>对违规账号、欺诈行为进行处罚公告时，我们会公开相关账号信息，或因您出现违反法律法规或违反 idoing 平台相关协议及规则的情况，或为保护 idoing 平台或公众的人身财产安全免遭侵害，我们将可能依据法律法规、平台协议或征得您同意的情况下公开您的账号信息。</li>
          </ol>

          <h3>（四）共享、转让、公开披露个人信息时事先征得授权同意的例外</h3>
          <p>以下情形中，我们共享、转让、公开披露您的个人信息无需事先征得您的授权同意：</p>
          <ol>
            <li>与个人信息控制者履行法律法规规定的义务相关的；</li>
            <li>与国家安全、国防安全直接相关的；</li>
            <li>与公共安全、公共卫生、重大公共利益直接相关的；</li>
            <li>与刑事侦查、起诉、审判和判决执行等直接相关的；</li>
            <li>出于维护您或其他个人的生命、财产等重大合法权益但又很难得到本人同意的；</li>
            <li>您自行向社会公众公开的个人信息；</li>
            <li>从合法公开披露的信息中收集个人信息的，如合法的新闻报道、政府信息公开等渠道。</li>
          </ol>
        </section>

        <section id="section-5" class="privacy-doc__section">
          <h2>五、我们如何保护和保存您的个人信息</h2>
          <h3>（一）您个人信息的保存</h3>
          <ol>
            <li><strong>存储地点</strong>：我们在中华人民共和国境内运营 idoing 服务中收集和产生的信息，仅存储在中华人民共和国境内。</li>
            <li>
              <strong>存储期限</strong>：您提供给我们的信息可能会由我们根据备份流程定期存档或存储，并且保留的时间为该等信息收集时的目的、向您提供我们的产品和服务、解决争议、建立法律抗辩、进行审计，追求合法的商业目的、执行我们的协议并遵守适用的法律所要求的时间。例如，《中华人民共和国电子商务法》要求商品和服务信息、交易信息保存时间自交易完成之日起不少于三年。
            </li>
          </ol>

          <h3>（二）我们将采取以下手段保护您的信息</h3>
          <ol>
            <li>我们一直都极为重视保护用户的个人信息安全，为此我们采用了符合行业标准的安全技术措施及组织和管理措施等保护措施以最大程度降低您的信息被泄露、毁损、误用、非授权访问、非授权披露和更改的风险。</li>
            <li>我们会采取符合业界标准的合理可行的安全措施和技术手段存储和保护您的个人信息，以防止您的信息丢失、遭到被未经授权的访问、公开披露、使用、修改、毁损、丢失或泄漏。我们会使用加密技术确保数据的保密性；我们会使用受信赖的保护机制防止数据遭到恶意攻击。</li>
            <li>我们定期对员工进行数据安全的意识培养和安全能力的培训，加强员工对于保护个人信息重要性的认识。我们会与接触您个人信息的员工、合作伙伴签署保密协议，明确岗位职责及行为准则。</li>
            <li>我们有责任和义务提醒您互联网并非绝对安全的环境，我们建议您按照要求使用复杂密码，不要泄露自己的密码/验证码，不要随意转借账号和设备给他人使用，注意保护您的设备和个人信息安全。</li>
            <li>如果我们的物理、技术或管理防护设施遭到破坏，导致信息被非授权访问、公开披露、篡改或毁坏，导致您的合法权益受损的，我们将在发现后 24 小时内启动应急预案，采取合理救济措施，以尽可能降低对您个人信息和其他权益的影响。</li>
          </ol>

          <h3>（三）个人隐私数据泄露事件处置</h3>
          <p>
            在不幸发生个人隐私数据泄露事件后，我们将按照相关法律法规的要求及时向您告知：个人隐私数据泄露的基本情况和可能的影响、我们已采取或将要采取的处置措施、您可自主防范和降低风险的建议、对您的补救措施等。我们同时将及时将事件相关情况以邮件、信函、电话、推送通知等方式告知您，难以逐一告知信息主体时，我们会采取合理、有效的方式发布公告。同时，我们还将按照监管部门要求，主动上报个人隐私数据泄露事件的处置情况。
          </p>
        </section>

        <section id="section-6" class="privacy-doc__section">
          <h2>六、您如何管理个人信息</h2>
          <p>我们非常重视您对个人信息的关注，并尽全力保护您对于您个人信息访问、更正、删除的权利，以使您拥有充分的能力保障您的隐私和安全。您的权利包括：</p>

          <h3>（一）访问、更正</h3>
          <p>
            我们鼓励您更新和修改您的信息以使其更准确有效。您可以查询、访问、管理您的个人账号信息。您也可以联系我们申请更正您的信息，我们承诺在 15
            个工作日内完成核查和处理。联系邮箱：<a :href="contactMailto">{{ contactEmail }}</a>
          </p>

          <h3>（二）删除</h3>
          <p>在以下情形中，您可以向我们提出删除个人信息的请求，但已做数据匿名化处理或法律法规另有规定的除外：</p>
          <ol>
            <li>处理目的已实现、无法实现或者为实现处理目的不再必要；</li>
            <li>我们停止提供产品或者服务，或者保存期限已届满；</li>
            <li>个人撤回同意；</li>
            <li>如果我们处理个人信息的行为违反了法律、行政法规或与您的约定；</li>
            <li>法律、行政法规规定的其他情形。</li>
          </ol>

          <h3>（三）拒绝、返还、转移、索取数据副本</h3>
          <p>您可以通过本政策文末提供的方式联系我们，向我们提出拒绝、返还、转移、索取个人信息副本的请求。我们承诺在 15 个工作日内完成核查和处理。</p>

          <h3>（四）改变您授权同意的范围</h3>
          <p>
            如您想更改相关权限的授权（例如：存储数据等），您可以通过您的硬件设备进行修改。您也可以通过注销账号的方式，永久撤回我们继续收集您个人信息的全部授权。当您收回同意后，我们将不再处理相应的个人信息。但您收回同意的决定，不会影响此前基于您的授权而开展的个人信息处理。
          </p>

          <h3>（五）提出异议</h3>
          <p>
            若您认为我们对您个人信息的处理违反了本政策或相关法律法规的要求，您可以发送邮件至
            <a :href="contactMailto">{{ contactEmail }}</a> 提出您的异议。我们承诺在 15 个工作日内完成回复和处理。
          </p>

          <h3>（六）注销</h3>
          <p>
            在您需要终止使用我们的服务时，您可以申请注销您的账户。我们承诺在 15 个工作日内完成核查和处理。账号一旦注销完成，将无法恢复。
          </p>
        </section>

        <section id="section-7" class="privacy-doc__section">
          <h2>七、未成年人信息的保护</h2>
          <p>
            我们非常重视对未成年个人信息的保护。idoing 主要面向成年人。若您是未满 18
            周岁的未成年人，在使用本产品前，应在您的父母或其他监护人的监护、指导下共同阅读并同意本隐私政策。
          </p>
          <p>
            若您是未满 16 周岁的未成年人的监护人，在使用 idoing 及相关服务前，应为您的被监护人阅读并同意本隐私政策。我们根据国家相关法律法规的规定保护未成年人的个人信息，只会在法律允许、父母或其他监护人明确同意或保护未成年人所必要的情况下收集、使用或披露未成年人的个人信息。
          </p>
        </section>

        <section id="section-8" class="privacy-doc__section">
          <h2>八、本政策如何更新</h2>
          <p>
            为了给您提供更好的服务，本隐私政策也会随之更新。我们会通过在 idoing 网站、移动端上发出更新版本并在生效前通过网站公告或以其他适当方式提醒您相关内容的更新，也请您访问
            idoing 以便及时了解最新的隐私政策。
          </p>
          <p>对于重大变更，我们还会提供更为显著的通知（我们会通过包括但不限于邮件、短信或在浏览页面做特别提示等方式，说明隐私政策的具体变更内容）。</p>
          <p>本隐私政策更新后，我们会在 idoing 发出更新版本，并在更新后的条款生效前通过公告或其他适当的方式提醒您更新的内容，以便您及时了解本隐私政策的最新版本。</p>
        </section>

        <section id="section-9" class="privacy-doc__section">
          <h2>九、如何联系我们</h2>
          <p>
            如您对本隐私政策有任何问题、意见或建议，或者需要就个人信息安全进行投诉、举报的，请发送邮件至
            <a :href="contactMailto">{{ contactEmail }}</a> 与我们联系，我们将在 15 个工作日内回复。
          </p>
        </section>
      </article>
    </div>
  </div>
</template>

<script>
export default {
  name: 'PrivacyPolicy',
  data() {
    return {
      contactEmail: 'pluskeji@126.com'
    }
  },
  computed: {
    contactMailto() {
      return `mailto:${this.contactEmail}`
    }
  },
  mounted() {
    document.title = 'idoing 隐私政策'
  },
  beforeDestroy() {
    document.title = 'idoing'
  },
  methods: {
    goBack() {
      if (window.history.length > 1) this.$router.go(-1)
      else this.$router.push('/')
    }
  }
}
</script>

<style scoped>
.privacy-page {
  position: relative;
  height: 100vh;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  -webkit-overflow-scrolling: touch;
  overscroll-behavior: contain;
  background: #0e1014;
  color: rgba(255, 255, 255, 0.82);
}
.privacy-page__backdrop {
  pointer-events: none;
  position: fixed;
  inset: 0;
  z-index: 0;
  background:
    radial-gradient(ellipse 120% 80% at 50% -20%, rgba(56, 100, 180, 0.16) 0%, transparent 55%),
    linear-gradient(180deg, #0e1014 0%, #161922 45%, #12141a 100%);
}
.privacy-page__inner {
  position: relative;
  z-index: 1;
  max-width: 860px;
  margin: 0 auto;
  padding: 32px 20px 64px;
}
.privacy-page__header {
  margin-bottom: 28px;
}
.privacy-page__back {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  margin-bottom: 20px;
  padding: 8px 14px;
  border: 1px solid rgba(255, 255, 255, 0.08);
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.04);
  color: rgba(255, 255, 255, 0.72);
  font-size: 13px;
  cursor: pointer;
  transition: background 0.2s ease, color 0.2s ease;
}
.privacy-page__back:hover {
  background: rgba(255, 255, 255, 0.08);
  color: #fff;
}
.privacy-page__title {
  margin: 0 0 10px;
  font-size: clamp(28px, 4vw, 36px);
  font-weight: 700;
  letter-spacing: -0.02em;
  color: #fff;
}
.privacy-page__meta {
  margin: 0;
  font-size: 13px;
  color: rgba(255, 255, 255, 0.42);
}
.privacy-page__meta-sep {
  margin: 0 8px;
}
.privacy-doc {
  padding: 28px 24px 36px;
  border: 1px solid rgba(255, 255, 255, 0.06);
  border-radius: 20px;
  background: rgba(255, 255, 255, 0.02);
  line-height: 1.85;
  font-size: 14px;
}
.privacy-doc__lead {
  margin-top: 0;
  font-size: 15px;
  color: rgba(255, 255, 255, 0.92);
}
.privacy-doc p {
  margin: 0 0 14px;
}
.privacy-doc a {
  color: #7dd3fc;
  text-decoration: none;
}
.privacy-doc a:hover {
  text-decoration: underline;
}
.privacy-doc__toc {
  margin: 24px 0 28px;
  padding: 18px 20px;
  border-radius: 14px;
  background: rgba(255, 255, 255, 0.03);
  border: 1px solid rgba(255, 255, 255, 0.05);
}
.privacy-doc__toc-title {
  margin: 0 0 10px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.88);
}
.privacy-doc__toc ol {
  margin: 0;
  padding-left: 20px;
}
.privacy-doc__toc li {
  margin: 6px 0;
}
.privacy-doc__section {
  margin-top: 32px;
  scroll-margin-top: 24px;
}
.privacy-doc__section h2 {
  margin: 0 0 14px;
  font-size: 20px;
  font-weight: 700;
  color: #fff;
}
.privacy-doc__section h3 {
  margin: 20px 0 10px;
  font-size: 16px;
  font-weight: 600;
  color: rgba(255, 255, 255, 0.92);
}
.privacy-doc ol,
.privacy-doc ul {
  margin: 0 0 14px;
  padding-left: 22px;
}
.privacy-doc li {
  margin: 8px 0;
}
@media (max-width: 640px) {
  .privacy-page__inner {
    padding: 20px 14px 48px;
  }
  .privacy-doc {
    padding: 20px 16px 28px;
  }
}
</style>
